<template>
  <b-tr>
    <b-td>
      <div class="handle">
        <move-icon class="move-icon" />
      </div>
    </b-td>
    <b-td>{{ productData.sku }}</b-td>
    <b-td>{{ productData.title }}</b-td>
    <b-td class="text-right">
      <b-dropdown
        id="dropdown-1"
        text="Select"
        class="m-md-2"
        no-caret
      >
        <template #button-content>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </template>
        <b-dropdown-item
          :href="`/node/${productData.id}`"
          rel="nofollow"
          target="_blank"
        >
          View Product
        </b-dropdown-item>
        <b-dropdown-item
          :href="`/node/${productData.id}/edit`"
          rel="nofollow"
          target="_blank"
        >
          Edit Product
        </b-dropdown-item>
        <b-dropdown-item
          variant="danger"
          @click="$emit('delete', id)"
        >
          Remove
        </b-dropdown-item>
      </b-dropdown>
    </b-td>
  </b-tr>
</template>

<script>
import { mapGetters } from 'vuex'
import MoveIcon from './MoveIcon'

export default {
  name: 'catalogue-product-data',
  components: {
    MoveIcon
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      products: 'catalogues/products'
    }),
    productData() {
      return this.products.find(x => x.nid === this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.move-icon { width: 30px; cursor: pointer;}
</style>
